import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm border-t border-gray-800" data-id="element-49">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-50">
        <p data-id="element-51">
          © 2026 DescargaTop – Pack 100 Citas Todos los derechos reservados
        </p>
        <div className="flex justify-center gap-4" data-id="element-52">
          <a href="#" className="hover:text-white transition-colors" data-id="element-53">
            Privacidad
          </a>
          <span data-id="element-54">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-55">
            Términos y Condiciones
          </a>
        </div>
      </div>
    </footer>;
}